// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2BZbS","modalForm":"UpgradeEpcsModal_modalForm__39-jU","modalFooter":"UpgradeEpcsModal_modalFooter__qCN0w"};